import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon", "spinner"]

  submit() {
    const button = this.element.querySelector("button, input[type='submit']")
    if (button) {
      button.disabled = true
      button.classList.add("opacity-50", "pointer-events-none")
    }
    this.iconTarget.classList.add("hidden")
    this.spinnerTarget.classList.remove("hidden")
  }

  reset() {
    const button = this.element.querySelector("button, input[type='submit']")
    if (button) {
      button.disabled = false
      button.classList.remove("opacity-50", "pointer-events-none")
    }
    this.iconTarget.classList.remove("hidden")
    this.spinnerTarget.classList.add("hidden")
  }
}
